import React from 'react';

// Reuses the flagcdn.com hosted PNGs (already vetted upstream in
// CountryPage). We don't render a fallback because the absence of a flag
// reads as "country unknown" — which is the truthful state. Country codes
// must be ISO 3166-1 alpha-2.
//
// `rounded` (M5): when true, the flag renders as a circle of `size × size`
// with object-cover so it reads as a small avatar-style badge alongside
// the city/region text on PostCard's meta row. Default false keeps the
// original aspect-correct rectangle for any existing caller.
export const CountryFlag = ({ code, size = 20, className = '', title, rounded = false }) => {
  if (!code) return null;
  const lc = String(code).toLowerCase();
  const widths = { 20: 'w20', 40: 'w40', 80: 'w80', 160: 'w160' };
  const widthKey = widths[size] || 'w20';
  const srcSet = `https://flagcdn.com/${widths[size * 2] || 'w40'}/${lc}.png 2x`;
  if (rounded) {
    return (
      <span
        className={`inline-block overflow-hidden rounded-full bg-gray-100 dark:bg-[#23252b] ${className}`}
        style={{ width: size, height: size, verticalAlign: 'middle' }}
        title={title || code}
      >
        <img
          src={`https://flagcdn.com/${widthKey}/${lc}.png`}
          srcSet={srcSet}
          alt={title || `${code} flag`}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </span>
    );
  }
  return (
    <img
      src={`https://flagcdn.com/${widthKey}/${lc}.png`}
      srcSet={srcSet}
      width={size}
      height={Math.round(size * 0.75)}
      alt={title || `${code} flag`}
      title={title || code}
      loading="lazy"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', borderRadius: 2 }}
    />
  );
};
